import { reduxKey, SimpleXHREndpoint } from './constants';
function getStateSlice(state) {
    return state[reduxKey];
}
export var getIsLoading = function (state, endpoint) {
    return getStateSlice(state).loadingEndpoints.includes(endpoint);
};
export var getIsLoadingForGivePointsXHR = function (state) {
    return getIsLoading(state, SimpleXHREndpoint.GIVE_POINTS);
};
export var getIsLoadingForGiveLlamaXHR = function (state) {
    return getIsLoading(state, SimpleXHREndpoint.GIVE_LLAMA);
};
export var getInitGivePointsPopupXHRCallResult = function (state) {
    return getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_POINTS_POPUP];
};
export var getGiveLlamaXHRCallResult = function (state) {
    return getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_LLAMA];
};
//# sourceMappingURL=selectors.js.map